"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _compose = _interopRequireDefault(require("recompose/compose"));

var _withHandlers = _interopRequireDefault(require("recompose/withHandlers"));

var _setWrappedDisplayName = _interopRequireDefault(require("./setWrappedDisplayName"));

var enhance = (0, _compose["default"])((0, _withHandlers["default"])({
  handleClick: function handleClick(_ref) {
    var onClick = _ref.onClick;
    return function (evt) {
      if (onClick) {
        onClick(evt);
      }
    };
  }
}), (0, _setWrappedDisplayName["default"])('ClickTracking'));
var _default = enhance;
exports["default"] = _default;